import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {EventsService} from "../../lib/EventsService";
import {FilterFormService} from "../filter_form/filter_form.service";
import merge from "lodash-es/merge";
import {PeriodService} from "./period.service";

@Component({
	selector: 'period',
	template: `
		<br>
		<div class="row ul-margin-bottom">
			<div class="col-md-12">
				<nav class="nav nav-pills">
					<ng-container *ngFor="let p of periodList">
						<a
							[class]="p == periodService.period ? 'period-tab text-sm-center nav-link active' : 'period-tab text-sm-center nav-link'"
							[routerLink]="['/' + baseUrl]" [queryParams]="getQueryParams(p)"
							[attr.tab]="p"
						>
							{{ 'adminstat.filterForm.' + p | translate }}
						</a>	  
					</ng-container>
				</nav>
			</div>
		</div>
	`
})
export class PeriodComponent implements OnInit {
	periodList: string[] = ['day', 'week', 'month', 'year', 'summary'];
	summaryS: string;
	summaryE: string;
	baseUrl: string = this.router.url.split('?')[0];
	showSummarySE: boolean = false;

	currentFP = null;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public eventsService: EventsService,
		public filter: FilterFormService,
		public periodService: PeriodService
		
	) {
		this.route.queryParams.subscribe((params: any) => {
			this.periodService.period = params.period || 'day';
			this.summaryS = params.summaryS || '';
			this.summaryE = params.summaryE || '';

			if(this.baseUrl == '/billing' && this.periodService.period == 'summary') {
				this.showSummarySE = true;
			} else {
				this.showSummarySE = false;

				this.summaryS = '';
				this.summaryE = '';
			}


			this.currentFP = params;

			this.eventsService.broadcast('period-change', this.periodService.period);
		});
	}
	
	
	async ngOnInit() {
		this.periodService.period = this.filter.filterParams.period;
	}
	
	
	applyPeriod() {
		this.router.navigate([this.baseUrl], {queryParams: this.getQueryParams('summary')});
	}
	
	
	getQueryParams(p) {
		let params = merge({}, this.currentFP, { period: p, page: 1 });

		if (p == 'summary') {
			if (this.summaryS != '') {
				params['summaryS'] = this.summaryS;
			}

			if (this.summaryE != '') {
				params['summaryE'] = this.summaryE;
			}
		}

		return params;
	}
}
